import React, { useEffect, useState } from "react"
import "./ViewUniversity.scss"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"

const ViewUniversity = () => {
  document.title = "View University"
  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation()
  // const universityData = location?.state
  const { universityCode } = useParams()
  const [universityData, setUniversityData] = useState({})

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "University", link: "#" },
    { label: "University Details", link: "#" },
  ]

  const getUniversityById = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    UniversityApi.getUniversityById(universityCode, config)
      .then(res => {
        setUniversityData(res.data.university)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (universityCode) {
      getUniversityById()
    }
  }, [universityCode])

  return (
    <div className="view-university">
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="University Details"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="university-view-form ">
                <div className="university-view-inp">
                  <label htmlFor="universityName" className="label">
                    University Name
                  </label>
                  <InputText
                    id="universityName"
                    value={universityData.universityName}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="displayName" className="label">
                    Display Name
                  </label>
                  <InputText
                    id="displayName"
                    value={universityData.displayName}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="type" className="label">
                    Type
                  </label>

                  <InputText
                    id="type"
                    value={universityData.type}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="yearEstablished" className="label">
                   Year Established
                  </label>
                  <InputText
                    id="yearEstablished"
                    value={universityData.yearEstablished}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="country" className="label">
                    Country
                  </label>
                  <InputText
                    id="country"
                    value={universityData.country}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="state" className="label">
                    State
                  </label>

                  <InputText
                    id="state"
                    value={universityData.state}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="username" className="label">
                    City
                  </label>
                  <InputText
                    id="city"
                    value={universityData.city}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="pinCode" className="label">
                    Pin Code
                  </label>
                  <InputText
                    id="pinCode"
                    value={universityData.pinCode}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="address" className="label">
                    Address
                  </label>
                  <InputText
                    id="address"
                    value={universityData.address}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                {/* <div className="university-view-inp">
                  <label htmlFor="phoneNumber" className="label">
                    Phone
                  </label>

                  <InputText
                    id="phoneNumber"
                    value={universityData.phone}
                    className="inp-field-box"
                    disabled
                  />
                </div> */}
                <div className="university-view-inp">
                  <label htmlFor="email" className="label">
                    Email
                  </label>
                  <InputText
                    id="email"
                    value={universityData.email}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="officialWebsite" className="label">
                  Official Website
                  </label>
                  <InputText
                    id="officialWebsite"
                    value={universityData.officialWebsite}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="campusSize" className="label">
                  Campus Size
                  </label>
                  <InputText
                    id="campusSize"
                    value={universityData.campusSize}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="noOfStudents" className="label">
                  No Of Students
                  </label>
                  <InputText
                    id="noOfStudents"
                    value={universityData.noOfStudents}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="noOfDepartments" className="label">
                  No Of Departments
                  </label>
                  <InputText
                    id="noOfDepartments"
                    value={universityData.noOfDepartments}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="noOfCourses" className="label">
                  No Of Courses
                  </label>
                  <InputText
                    id="noOfCourses"
                    value={universityData.noOfCourses}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="totalFaculty" className="label">
                  Total Faculty
                  </label>
                  <InputText
                    id="totalFaculty"
                    value={universityData.totalFaculty}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="nirfRanking" className="label">
                  NIRF Ranking
                  </label>
                  <InputText
                    id="nirfRanking"
                    value={universityData.nirfRanking}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                  India Today 2023 Ranking
                  </label>
                  <InputText
                    id="indiaToday2023Ranking"
                    value={universityData.indiaToday2023Ranking}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="timesRanking2024" className="label">
                  Times Ranking 2024
                  </label>
                  <InputText
                    id="timesRanking2024"
                    value={universityData.timesRanking2024}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                
                {/* <div className="university-view-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <InputText
                    id="description"
                    value={universityData.description}
                    className="inp-field-box"
                    disabled
                  />
                </div> */}
                <div className="university-view-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <InputText
                    id="ugcApproval"
                    value={universityData.ugcApproval ? "Yes" : "No"}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <InputText
                    id="aiuAffiliation"
                    value={universityData.aiuAffiliation ? "Yes" : "No"}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="highlights" className="label">
                  Highlights
                  </label>
                  <InputText
                    id="highlights"
                    value={universityData.highlights}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="aboutContent" className="label">
                  AboutContent
                  </label>
                  <InputText
                    id="aboutContent"
                    value={universityData.aboutContent}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="verifiedStatus" className="label">
                    Verified Status
                  </label>
                  <InputText
                    id="verifiedStatus"
                    value={
                      universityData.verifiedStatus === "approve" ? "Yes" : "No"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="verifiedReason" className="label">
                    Verified Reason
                  </label>
                  <InputText
                    id="verifiedReason"
                    value={
                      universityData.verifiedReason
                        ? universityData.verifiedReason
                        : "-"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Back
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ViewUniversity
